// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1FnId","title":"ClientCherryInfo_title__B-vxm","itemText":"ClientCherryInfo_itemText__9eF-T"};